// Supported operating systems for the threat hunter agent downloads.
// The installer/collector files share the same base name and only differ
// by extension, e.g. CFSetup.msi / CFSetup.dmg / CFSetup.deb / CFSetup.rpm
export const AGENT_OS_OPTIONS = [
  {
    id: "windows",
    value: "Windows",
    installerExtension: "msi",
    collectorExtension: "zip",
  },
  {
    id: "macos",
    value: "macOS",
    installerExtension: "dmg",
    collectorExtension: "tar.gz",
  },
  {
    id: "ubuntu",
    value: "Linux - Ubuntu / Debian",
    installerExtension: "deb",
    collectorExtension: "tar.gz",
  },
  {
    id: "redhat",
    value: "Linux - RedHat / CentOS",
    installerExtension: "rpm",
    collectorExtension: "tar.gz",
  },
];

export const DEFAULT_AGENT_OS = AGENT_OS_OPTIONS[0];

export const getAgentOs = (osId) =>
  AGENT_OS_OPTIONS.find((option) => option.id === osId) || DEFAULT_AGENT_OS;
